import {createTheme} from "@mui/material";

export const THEME = createTheme({
    typography: {
        "fontFamily": `"ADLaM Display", "Roboto", "Helvetica", "Arial", sans-serif`,
        "fontSize": 14,
        "fontWeightLight": 300,
        "fontWeightRegular": 400,
        "fontWeightMedium": 500
    },
});